import { Shield, Users, BarChart3, Settings } from "lucide-react"
import { LoginForm } from "@/components/auth/LoginForm"
import Logo from "@/components/Logo"

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <div className="grid min-h-screen lg:grid-cols-2">
        {/* Left Side - Login Form */}
        <div className="flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between p-6 md:p-10">
            <Logo size="lg" className="text-slate-800"  showText={false}/>
            <div className="hidden md:flex items-center gap-2 text-sm text-slate-600">
              <Shield className="h-4 w-4" />
              <span>Admin Portal</span>
            </div>
          </div>

          {/* Login Form Container */}
          <div className="flex flex-1 items-center justify-center p-6">
            <div className="w-full max-w-md">
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20 p-8">
                <div className="text-center mb-8">
                  <h1 className="text-3xl font-bold text-slate-900 mb-2">
                    Welcome Back
                  </h1>
                  <p className="text-slate-600">
                    Sign in to your SAIF Admin dashboard
                  </p>
                </div>
                <LoginForm />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="p-6 text-center text-sm text-slate-500">
            <p>&copy; 2025 SAIF All rights reserved.</p>
          </div>
        </div>

        {/* Right Side - Hero Section */}
        <div className="relative hidden lg:block bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600" style={{background: "#10121A"}}>
          <div className="absolute inset-0 bg-black/20" />
          <div className="relative h-full flex items-center justify-center p-12">
            <div className="text-center text-white space-y-8 max-w-md">
              {/* Logo */}
              <div className="flex justify-center">
                <Logo size="xl" textClassName="text-white text-3xl" showFull={true} />
              </div>

              {/* Features */}


            </div>
          </div>

          {/* Decorative Elements */}
          <div className="absolute top-10 right-10 w-20 h-20 bg-white/10 rounded-full blur-xl" />
          <div className="absolute bottom-20 left-10 w-32 h-32 bg-pink-500/20 rounded-full blur-2xl" />
          <div className="absolute top-1/2 right-20 w-16 h-16 bg-blue-500/20 rounded-full blur-xl" />
        </div>
      </div>
    </div>
  )
}